
<h3 i18n>Individuelles Angebot abgelaufen</h3>

<p>
  <ng-container i18n>Ihr individuelles Angebot ist leider abgelaufen.</ng-container>
  @if (data.config.template_data['price-suggest']) {
    <ng-container i18n>
      Sie haben weiterhin die Möglichkeit einen weiteren Preisvorschlag abzugeben
      oder die Domain für den regulären Verkaufspreis zu erwerben.
    </ng-container>
  } @else {
    <ng-container i18n>
      Preisvorschläge wurden in der Zwischenzeit deaktiviert.
      Alternativ haben Sie die Möglichkeit die Domain für den regulären Verkaufspreis zu erwerben.
    </ng-container>
  }
</p>

<div class="ed-actions">
  <div (click)="offer()" [edButton]="{ theme: 'default' }" i18n>
    Preisvorschlag
  </div>
  <div (click)="close()" [edButton]="{ theme: 'light' }" i18n>
    Zur Verkaufsseite
  </div>
</div>
